/**
 * Helpers centralisés pour gérer le "PIN mode".
 *
 * Convention actuelle:
 * - `auth_method=pin` + `is_authenticated=true` => session PIN active
 * - `manager_pin` contient le PIN saisi (utilisé pour les RPC sécurisées)
 */

export const shouldUsePinMode = (): boolean => {
  if (typeof window === 'undefined') return false;

  const authMethod = window.localStorage.getItem('auth_method');
  const isAuthenticated = window.localStorage.getItem('is_authenticated') === 'true';
  const pin = window.localStorage.getItem('manager_pin');

  return authMethod === 'pin' && isAuthenticated && Boolean(pin);
};

export const getUserPinOrThrow = (): string => {
  const pin = typeof window !== 'undefined' ? window.localStorage.getItem('manager_pin') : null;
  if (!pin) throw new Error('PIN utilisateur manquant');
  return pin;
};

